// أنواع الجلسات الموحدة
export const sessionTypes = {
  court: { label: "جلسة قضائية", variant: "info" },
  appeal: { label: "استئناف", variant: "warning" },
  consultation: { label: "استشارة", variant: "success" },
  other: { label: "جلسة أخرى", variant: "secondary" },
  "جلسة قضائية": { label: "جلسة قضائية", variant: "info" },
  استئناف: { label: "استئناف", variant: "warning" },
  استشارة: { label: "استشارة", variant: "success" },
  "جلسة أخرى": { label: "جلسة أخرى", variant: "secondary" },
  أخرى: { label: "جلسة أخرى", variant: "secondary" },
  قضائية: { label: "جلسة قضائية", variant: "info" },
  تحقيق: { label: "جلسة تحقيق", variant: "danger" },
  مرافعة: { label: "جلسة مرافعة", variant: "primary" },
  مداولة: { label: "جلسة مداولة", variant: "default" },
  تنفيذ: { label: "جلسة تنفيذ", variant: "warning" },
  صلح: { label: "جلسة صلح", variant: "success" },
  "جلسة استماع أولية": { label: "جلسة استماع أولية", variant: "info" },
  "جلسة نطق بالحكم": { label: "جلسة نطق بالحكم", variant: "primary" },
  "جلسة استماع للشهود": { label: "جلسة استماع للشهود", variant: "info" },
  تمييز: { label: "تمييز", variant: "warning" },
};

// قائمة بالخيارات للقائمة المنسدلة
export const sessionTypeOptions = [
  { value: "جلسة قضائية", label: "جلسة قضائية" },
  { value: "استئناف", label: "استئناف" },
  { value: "استشارة", label: "استشارة" },
  { value: "أخرى", label: "أخرى" },
  { value: "تحقيق", label: "تحقيق" },
  { value: "مرافعة", label: "مرافعة" },
  { value: "مداولة", label: "مداولة" },
  { value: "تنفيذ", label: "تنفيذ" },
  { value: "صلح", label: "صلح" },
  { value: "جلسة استماع أولية", label: "جلسة استماع أولية" },
  { value: "جلسة نطق بالحكم", label: "جلسة نطق بالحكم" },
  { value: "جلسة استماع للشهود", label: "جلسة استماع للشهود" },
  { value: "تمييز", label: "تمييز" },
];
